import React from "react";
import ReactDOM from "react-dom";
import { FiX, FiInfo } from "react-icons/fi";

// Type-safe icon wrappers
const CloseIcon = FiX as React.FC<React.SVGProps<SVGSVGElement>>;
const InfoIcon = FiInfo as React.FC<React.SVGProps<SVGSVGElement>>;

interface PostHogInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}

/**
 * PostHogInfoModal - Informational modal for PostHog API key setup
 * Displays before the Nango connection flow for PostHog
 */
const PostHogInfoModal: React.FC<PostHogInfoModalProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className="su-modal-overlay" onClick={handleBackdropClick}>
      <div className="su-modal" style={{ maxWidth: "500px" }}>
        {/* Header */}
        <div className="su-modal-header">
          <div className="su-modal-title">
            <InfoIcon style={{ width: "20px", height: "20px" }} />
            <span>POSTHOG REQUIRES API KEYS</span>
          </div>
          <button type="button" className="su-modal-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <div className="su-modal-body" style={{ padding: "24px" }}>
          <p
            style={{
              color: "#D1D5DB",
              marginBottom: "20px",
              fontSize: "14px",
              lineHeight: "1.6",
            }}
          >
            PostHog uses API keys for authentication instead of OAuth.
          </p>

          <div
            style={{
              backgroundColor: "rgba(102, 126, 234, 0.1)",
              border: "1px solid rgba(102, 126, 234, 0.3)",
              padding: "16px",
              borderRadius: "6px",
              marginBottom: "20px",
            }}
          >
            <p
              style={{
                color: "#D1D5DB",
                fontSize: "14px",
                lineHeight: "1.6",
                margin: 0,
              }}
            >
              Look at the docs for more information on how to create an API key:{" "}
              <a
                href="https://nango.dev/docs/integrations/all/posthog/connect"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#667eea",
                  textDecoration: "underline",
                  fontWeight: 600,
                }}
              >
                PostHog API Key Documentation
              </a>
            </p>
          </div>

          <p
            style={{
              color: "#9CA3AF",
              fontSize: "14px",
              lineHeight: "1.6",
              marginBottom: 0,
            }}
          >
            Once you have your API key and PostHog domain, you can continue.
          </p>
        </div>

        {/* Footer */}
        <div className="su-modal-footer" style={{ justifyContent: "space-between" }}>
          <button
            type="button"
            className="su-btn-secondary"
            onClick={onClose}
            style={{
              padding: "10px 20px",
              fontSize: "13px",
              fontWeight: "600",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Close
          </button>
          <button
            type="button"
            onClick={onContinue}
            style={{
              padding: "10px 24px",
              backgroundColor: "#667eea",
              color: "#FFFFFF",
              border: "1px solid #667eea",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "13px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#5568d3";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#667eea";
            }}
          >
            Continue
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PostHogInfoModal;

